import { isFunction, isNumber } from 'lodash'
import { getCustomRowCellAlignClass } from 'public/components/kye-table2/config/columns.js'
import { MIN_COLUMN_WIDTH } from 'public/components/kye-table2/config'
import { $utils } from 'public/utils'

export function createOperationColumn(options) {
  const { operation } = options
  const { options: buttonOpt, ...restOpt } = operation
  return {
    ...restOpt,
    key: restOpt.key || '__operation_key',
    width: parseInt(restOpt.width) || MIN_COLUMN_WIDTH,
    rowCellRender: createOperationRender(options, buttonOpt),
  }
}

export function createOperationRender(options, buttonOpt) {
  return function (h, renderArgs) {
    const { rowData } = renderArgs
    return h('div', {
      class: ['table2-warp-custom-operation', ...getCustomRowCellAlignClass(renderArgs.column)].filter(Boolean),
    },
      buttonOpt.filter(i => {
        const _show = isFunction(i.show) ? i.show(i, rowData, renderArgs) : i.show
        return _show !== false
      }).map(item => createdButtonRender(h, item, renderArgs, options))
    )
  }
}

function getDisabledStutas(rowData, { auth, disabled }, options) {
  const { permission } = options
  return (auth && !permission.menus.includes(auth)) || (typeof disabled === 'function' ? disabled(rowData) : !!disabled)
}

// 兼容自定义操作列和自定义按钮列
export function createdButtonRender(h, btnOpt, renderArgs, options = {}) {
  const { vm } = options
  const { rowData, column } = renderArgs
  let {
    props = {},
    label,
    render,
    func,
    type,
    icon,
    textColor,
    color: iconColor,
    iconSize = 16
  } = btnOpt
  const _disabled = getDisabledStutas(rowData, btnOpt, options)
  const content = (isFunction(label) ? label(rowData, btnOpt, renderArgs) : label) || renderArgs.value
  const _textColor = isFunction(textColor) ? textColor(rowData, btnOpt, renderArgs) : textColor
  const _iconColor = isFunction(iconColor) ? iconColor(rowData, btnOpt, renderArgs) : iconColor
  if (isFunction(icon)) icon = icon(rowData, btnOpt, renderArgs)

  const buttonType = `table2-button_${props.type || 'text'}`
  const _createButton = () => h('div', {
    // props: {
    //   ...props,
    //   type: props.type || 'text',
    //   disabled: _disabled
    // },
    class: {
      'table2-warp-custom-btn': true,
      'table2-button': true,
      'table2-button_disabled': _disabled,
      [`${buttonType}`]: true
    },
    style: {
      color: _textColor || _iconColor,
      userSelect: 'all'
    },
    on: {
      click: () => {
        // 先解密在走buttonOptions, 判断是否加解密且不是敏感字段
        const isEncryption = $utils.decryptApi.isEncrypted(rowData, column.key) && !$utils.decryptApi.isMaskSec(rowData, column.key)
        if (_disabled || isEncryption) return
        if (type === 'link') {
          const routePath = func && isFunction(func) ? func(rowData, btnOpt) : func
          routePath && vm && vm.$router.push(routePath)
          return
        }
        func && isFunction(func) && func(rowData, renderArgs)
      }
    }
  }, content)
  const customIconfont = vm.$props.options && vm.$props.options.iconfont
  // 目前参考quert-table实现，无法做到控制左右icon的位置
  const _createIconContainer = () => {
    const [iconUincode, text] = icon.split(';')
    const isIcon = iconUincode.includes('&#x')
    return h('div', {
      class: 'table2-warp-custom-btn_icon-wrapper',
      style: {
        color: _textColor,
      },
      on: {
        click: () => {
          if (!_disabled) func && isFunction(func) && func(rowData)
        }
      }
    },
    [
      isIcon &&
        h('i', {
          class: ['iconfont', customIconfont].filter(Boolean).join(' '),
          style: {
            color: _iconColor,
            fontSize: isNumber(iconSize) ? iconSize + 'px' : iconSize
          },
          domProps: {
            innerHTML: iconUincode,
          },
        }),
        (isIcon ? text : icon)
    ])
  }

  const renderContent = () => {
    return icon ? h('div', {
      class: {
        'table2-warp-custom-btn-wrapper': true,
      }
    },
    [
      _createIconContainer(),
    ])
    // 操作列
    : _createButton()
  }

  return isFunction(render)
    ? render(h, btnOpt, renderArgs, options)
    : renderContent()
}



// WEBPACK FOOTER //
// ./src/public/components/query-table/table2/feature/operation-render.js